import { ButtonColor, ButtonColors, PaletteColor } from '../types';

const SEMANTIC_BUTTON_COLORS: ReadonlySet<string> = new Set(
  Object.values(ButtonColors),
);

export const isSemanticButtonColor = (
  color: ButtonColor | PaletteColor,
): color is ButtonColor => SEMANTIC_BUTTON_COLORS.has(color);

export type ResolvedColor = {
  classKey: ButtonColor | 'paletteToken';
  style?: React.CSSProperties;
};

export const resolveColor = (
  color: ButtonColor | PaletteColor,
): ResolvedColor => {
  if (isSemanticButtonColor(color)) {
    return { classKey: color };
  }
  return {
    classKey: 'paletteToken',
    style: {
      ['--btn-palette-bg' as string]: `var(--${color})`,
    } as React.CSSProperties,
  };
};
